export default "__VITE_PUBLIC_ASSET__bb750019__"